import { IDateDelimiter, ListItemTypename } from 'listItem.types'
import { MMM_DD_YYYY } from 'utility/timeFormats'

export const getDateSeparatedList =
  <T extends { occurredAt?: string; createdAt?: string | null }>(
    formatWithTimeZone: (date: Date | string | number, dateFormat: string) => string,
    includeTopDateSeparator: boolean = false,
    separateByMonth: boolean = false
  ) =>
  (listItems: T[]) => {
    if (!listItems.length) return []
    const dateFormat = separateByMonth ? 'MMM yyyy' : MMM_DD_YYYY
    const itemDate = (item: T) => {
      const date = item.occurredAt || item.createdAt
      return date ? formatWithTimeZone(date, dateFormat) : ''
    }
    let currentDate = includeTopDateSeparator ? '' : itemDate(listItems[0])

    const dateSeparatedItems = listItems.reduce(
      (acc: (T | IDateDelimiter)[], listItem: T, i: number) => {
        const nextCurrentDate = itemDate(listItem)

        if (nextCurrentDate && nextCurrentDate !== currentDate) {
          currentDate = nextCurrentDate
          acc.push({
            id: `date-section-${i}`,
            __typename: ListItemTypename.DateDelimiter,
            date: currentDate
          })
        }
        acc.push(listItem)

        return acc
      },
      []
    )

    return dateSeparatedItems
  }
